import { useState, useEffect } from "react";
import SocialNetworksCarousel from "./SocialNetworksCarousel";
import { CountryService } from "../../services/CountryService";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Divider } from "primereact/divider";
import NewsTable from "../Common/NewsTable";
import LawRegulationsTable from "../Common/LawRegulationsTable";
import { AddHomePageHeader } from "../Common/Utils";
import JobsTable from "../Common/JobsTable";
import NewsletterTable from "../Common/NewsletterTable";
import IndexTable from "../Common/IndexTable";

const Home = () => {
  const [news, setNews] = useState([]);
  const [dailydatabasereview, setDailyDatabaseReview] = useState([]);
  const [newsletter, setNewsletter] = useState([]);
  const [migration, setMigration] = useState([]);
  const [passports, setPassports] = useState([]);
  const [bibliography, setBibliography] = useState([]);
  const [index, setIndex] = useState([]);
  const [honoraryBibliography, setHonoraryBibliography] = useState([]);
  const [honoraryNews, setHonoraryNews] = useState([]);
  const [laws, setLaws] = useState([]);
  const [jobs, setJobs] = useState([]);

  const countryService = new CountryService();

  useEffect(() => {
    countryService.getNews(5).then((data) => setNews(data));
    countryService
      .getDailyDatabaseReview(5)
      .then((data) => setDailyDatabaseReview(data));
    countryService.getNewsletter(5).then((data) => setNewsletter(data));
    countryService.getMigrations(5).then((data) => setMigration(data));
    countryService.getPassports(5).then((data) => setPassports(data));
    countryService.getBibliography(5).then((data) => setBibliography(data));
    countryService.getIndex(5).then((data) => setIndex(data));
    countryService
      .getHonoraryBibliography(5)
      .then((data) => setHonoraryBibliography(data));
    countryService.getHonoraryNews(5).then((data) => setHonoraryNews(data));
    countryService.getHonoraryJobs(5).then((data) => setJobs(data));
    countryService.getLaws(5).then((data) => setLaws(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddHomePageHeader()}
      <div>
        <div className="grid" style={{ height: "100%" }}>
          {/* Left images */}
          <div className="col-9">
            <div
              className="flex flex-row align-items-center justify-content-center"
              style={{ height: "100%" }}
            >
              <a
                href="https://arcg.is/1TDPiy1"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "black",
                  fontWeight: "bold",
                  width: "32%",
                  marginRight: "1%",
                }}
              >
                <img
                  src="visuals/Homepage-1.png"
                  width="100%"
                  alt="Homepage 1"
                />
              </a>
              <a
                href="https://magazine.consularaffairs.org/"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "black",
                  fontWeight: "bold",
                  width: "32%",
                  marginRight: "1%",
                }}
              >
                <img
                  src="visuals/Homepage-2.png"
                  width="100%"
                  alt="Homepage 2"
                />
              </a>
              <a
                href="https://newsletter.consularaffairs.org/"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "black",
                  fontWeight: "bold",
                  width: "32%",
                }}
              >
                <img
                  src="visuals/Homepage-3.png"
                  width="100%"
                  alt="Homepage 3"
                />
              </a>
            </div>
          </div>
          {/* Right cards */}
          <div className="col-3">
            <div
              className="flex flex-column h-full gap-3"
              style={{ height: "100%" }}
            >
              <div className="flex-1">
                <Link
                  to="/support-consular-research"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div
                    className="text-center p-3 border-round-sm h-full flex flex-column justify-content-center"
                    style={{
                      border: "2px solid black",
                      background: "#fff",
                      color: "#000",
                    }}
                  >
                    <div>
                      <b>Become a Member</b>
                    </div>
                    <br />
                    <div>The Consular Association</div>
                  </div>
                </Link>
              </div>
              <div className="flex-1">
                <a
                  href="https://zenodo.org/communities/theconsularrepository/curation-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                    <div>
                      <b>Archive your existing documents</b>
                    </div>
                    <br />
                    <div>The Consular Repository</div>
                  </div>
                </a>
              </div>
              <div className="flex-1">
                <a
                  href="https://magazine.consularaffairs.org/p/write-in-the-magazine"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                    <div>
                      <b>Have an analysis, essay, opinion, or story?</b>
                    </div>
                    <br />
                    <div>The Consular Magazine</div>
                  </div>
                </a>
              </div>
              <div className="flex-1">
                <Link
                  to="/the-consular-bibliography"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                    <div>
                      <b>Reference your writings</b>
                    </div>
                    <br />
                    <div>The Consular Bibliography</div>
                  </div>
                </Link>
              </div>
              <div className="flex-1">
                <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                  <div>
                    <b>Submit an academic article </b>
                  </div>
                  <br />
                  <div>The Consular Journal (TBA)</div>
                </div>
              </div>
              <div className="flex-1">
                <Link
                  to="/update"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                    <div>
                      <b>Update</b>
                    </div>
                    <br />
                    <div>The Database and Rankings</div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <Divider />
        <div className="home-row">
          <div className="home-col21">
            <h3 className="section-title">
              The Consular Daily Press Review{" "}
              <Link
                to="/the-consular-daily-press-review"
                style={{ color: "black" }}
              >
                <i className="pi pi-external-link"></i>
              </Link>
            </h3>
            <NewsTable data={news} />
          </div>
          <div className="home-col22">
            <h3 className="section-title">
              Daily database review{" "}
              <Link to="/daily-database-review" style={{ color: "black" }}>
                <i className="pi pi-external-link"></i>
              </Link>
            </h3>
            <NewsTable data={dailydatabasereview} />
          </div>
          <div className="home-col23">
            <div className="home-social-networks">
              <h3 className="section-title">Get daily news</h3>
              <SocialNetworksCarousel />
            </div>
          </div>
        </div>
        <Divider />
        <div className="home-row">
          <div className="home-col21">
            <h3 className="section-title">
              The Consular Newsletter{" "}
              <Link to="/the-consular-newsletter" style={{ color: "black" }}>
                <i className="pi pi-external-link"></i>
              </Link>
            </h3>
            <NewsletterTable data={newsletter} />
          </div>
          <div className="home-col22">
            <h3 className="section-title">
              Migration laws, regulations, and policies{" "}
              <Link
                to="/migration-laws-regulations-and-policies"
                style={{ color: "black" }}
              >
                <i className="pi pi-external-link"></i>
              </Link>
            </h3>
            <NewsTable data={migration} />
          </div>
          <div className="home-col23">
            <h3 className="section-title">
              Passports, visas, and migration fraud{" "}
              <Link
                to="/passports-visas-and-migration-fraud"
                style={{ color: "black" }}
              >
                <i className="pi pi-external-link"></i>
              </Link>
            </h3>
            <NewsTable data={passports} />
          </div>
        </div>
        <Divider />
        <div className="home-row">
          <div className="home-col21">
            <h3 className="section-title">
              The Consular Bibliography{" "}
              <Link to="/the-consular-bibliography" style={{ color: "black" }}>
                <i className="pi pi-external-link"></i>
              </Link>
            </h3>
            <DataTable value={bibliography} responsiveLayout="scroll">
              <Column field="year" header="Year" sortable></Column>
              <Column field="title" header="Title" sortable></Column>
              <Column field="author" header="Author" sortable></Column>
            </DataTable>
          </div>
          <div className="home-col22">
            <h3 className="section-title">
              International organizations{" "}
              <Link
                to="/international-organizations"
                style={{ color: "black" }}
              >
                <i className="pi pi-external-link"></i>
              </Link>
            </h3>
            <LawRegulationsTable data={laws} />
          </div>
          <div className="home-col23">
            <h3 className="section-title">
              Index{" "}
              <Link to="/index" style={{ color: "black" }}>
                <i className="pi pi-external-link"></i>
              </Link>
            </h3>
            <IndexTable data={index} />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            margin: "2rem 0",
          }}
        >
          <div
            style={{
              flex: 1,
              borderTop: "1px solid #000",
            }}
          ></div>

          <span
            style={{
              padding: "0 1rem",
              fontWeight: "bold",
            }}
          >
            <h3>Honorary consuls</h3>
          </span>

          <div
            style={{
              flex: 1,
              borderTop: "1px solid #000",
            }}
          ></div>
        </div>
        <div className="home-row">
          <div className="home-col21">
            <h3 className="section-title">
              Honorary bibliography{" "}
              <Link to="/honorary-bibliography" style={{ color: "black" }}>
                <i className="pi pi-external-link"></i>
              </Link>
            </h3>
            <DataTable value={honoraryBibliography} responsiveLayout="scroll">
              <Column field="year" header="Year" sortable></Column>
              <Column field="title" header="Title" sortable></Column>
              <Column field="author" header="Author" sortable></Column>
            </DataTable>
          </div>
          <div className="home-col22">
            <div className="home-social-networks">
              <h3 className="section-title">
                Honorary jobs{" "}
                <Link to="/honorary-jobs" style={{ color: "black" }}>
                  <i className="pi pi-external-link"></i>
                </Link>
              </h3>
              <JobsTable data={jobs} />
            </div>
          </div>
          <div className="home-col23">
            <h3 className="section-title">
              Honorary news{" "}
              <Link to="/honorary-news" style={{ color: "black" }}>
                <i className="pi pi-external-link"></i>
              </Link>
            </h3>
            <NewsTable data={honoraryNews} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
